import { render } from "./ViewSubmissionModal.html?vue&type=template&id=610a9ecb&scoped=true"
import script from "./ViewSubmissionModal.js?vue&type=script&lang=js"
export * from "./ViewSubmissionModal.js?vue&type=script&lang=js"

import "./ViewSubmissionModal.css?vue&type=style&index=0&id=610a9ecb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610a9ecb"]])

export default __exports__